import { gql } from '@apollo/client';

export const UPDATE_BEHAVIOR_PARAM = gql`
  mutation updateBehaviorParam($input: InitializationParameterInput) {
    updateBehaviorParam(input: $input) {
      commandId
    }
  }
`;

export const UPDATE_INITIALIZATION_PARAM = gql`
  mutation updateInitializationParam($input: InitializationParameterInput) {
    updateInitializationParam(input: $input) {
      commandId
    }
  }
`;

export const RUN_HEALTH_CHECKS = gql`
  mutation runHealthChecks($input: RunHealthChecksInput) {
    runHealthChecks(input: $input) {
      commandId
    }
  }
`;
